export default "<div class=\"loader\" *ngIf=\"isLoading\">\r\n  <div class=\"lds-ripple\">\r\n    <div></div>\r\n    <div></div>\r\n  </div>\r\n</div>\r\n";